 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"HighCharts":"HighCharts","AmCharts":"AmCharts","ApexChart":"ApexChart","canvg":"canvg","xlsx":"xlsx","pdfmake":"pdfmake"}[chunkId]||chunkId) + "." + {"HighCharts":"3f7f45a4","chunk-00708955":"ed8fd8ba","chunk-069c39b2":"3ec5c4df","chunk-0a7afad9":"46d463a1","chunk-0ed070e4":"ad867dc3","chunk-0f330e6e":"7ddea2e4","chunk-10de2f8e":"c378198e","chunk-2d0e5f17":"a0b23132","chunk-122008f8":"d9726fdd","chunk-133a29fb":"77e09831","chunk-13d049f5":"934ebcb3","chunk-13f3215e":"b2027b13","chunk-159956d9":"f0174aaf","chunk-19a3accc":"9e06128f","chunk-1ac6c498":"6f978359","chunk-1c24da7b":"5876e42a","chunk-21481cb4":"09c8d9cd","chunk-217b2e92":"9beea8a8","chunk-25ebe9a8":"9659ec1c","chunk-264d486b":"b04007e0","chunk-26969f90":"0f654824","chunk-277a78fa":"8f341b9e","chunk-2a206364":"1eb96137","chunk-2b0a2569":"4b584352","chunk-2d0a4c18":"1f700bf9","chunk-2d0ac5dd":"4025a6cf","chunk-2d0ae599":"281a2543","chunk-2d0afe6a":"7c3e8cf4","chunk-2d0b3dcd":"3c5744a9","chunk-2d0b8e0a":"fb63a0ed","chunk-2d0bacb6":"78c88919","chunk-2d0bd5e9":"2ab3a640","chunk-2d0bfed3":"6cc7bff7","chunk-2d0c04b2":"f80d840d","chunk-2d0c5368":"229922ae","chunk-2d0c5398":"c7e424af","chunk-2d0c7b81":"3c6fff9b","chunk-2d0c840a":"817ae2e4","chunk-2d0cbad6":"a1a6231e","chunk-2d0cbe59":"b9cc6e6b","chunk-2d0cc807":"99f3a2c6","chunk-2d0ccbc7":"faa37f96","chunk-2d0cedba":"3181572b","chunk-2d0d3a0a":"2081117c","chunk-2d0d5c6b":"07b8020a","chunk-2d0d6377":"9e2cebbc","chunk-2d0da2e7":"e443b96e","chunk-2d0dda3b":"76a481ba","chunk-2d0e2123":"9615a3fe","chunk-2d0e6514":"988a1b75","chunk-2d207398":"42a7b96a","chunk-2d207f54":"cf0e6640","chunk-2d209132":"a8b82b52","chunk-2d20eda9":"2ae176da","chunk-6535798c":"cb6fffe9","chunk-2d20f7a3":"96ae1aac","chunk-2d216798":"a5638d9f","chunk-2d217eb6":"db05f131","chunk-2d219fca":"d98d546e","chunk-2d21a395":"4b6b7d07","chunk-2d21d826":"fb8181db","chunk-2d226159":"50b4148c","chunk-2d2268fd":"74d0a0c7","chunk-2d2374f7":"b7a0eb5e","chunk-2d238257":"2f45d503","chunk-2d5809e0":"787822fd","chunk-2da2eae6":"30204eee","chunk-30a97249":"9a5b335b","chunk-33192879":"b09d46b1","chunk-38360029":"3cb460e6","chunk-281a48e4":"946cd47c","chunk-29f55c97":"06456700","chunk-7cddbf05":"f2c143e4","chunk-3c1a52a8":"e7b5012c","chunk-3f7871e3":"6ef6ad68","chunk-b3b78c88":"39fb24c0","chunk-bbdb5e62":"35a5a221","chunk-2200adb7":"3515b52a","chunk-f2256754":"3676c976","chunk-33efa541":"04c501ed","chunk-53bc0ede":"47a8c827","chunk-75383bc3":"43f2c8c6","chunk-b3869918":"21952777","chunk-4a49d1f9":"3f005f91","chunk-04188563":"8c9e95bd","chunk-2d0c46e5":"a606d2ac","chunk-4a8e3c68":"4bec77fb","chunk-4bbc9ae6":"5553f510","chunk-4ffedc49":"9ef21b67","chunk-54ad82df":"9294cc9e","chunk-55508ccf":"e9b35c56","chunk-5881a87b":"869deaf4","chunk-595881f2":"004425b3","chunk-5af2ec7c":"3910857b","chunk-62fe045e":"73ba4e1c","chunk-758d23ba":"5a56fac8","chunk-77b2bf02":"12135b38","chunk-78b53006":"25acffd2","chunk-7c6ce858":"5f093e85","chunk-7ca2337b":"896c321c","chunk-7ea345ab":"fdc7a935","chunk-7f7d0fc8":"824d9395","chunk-20ee07b8":"5bdcfd8c","chunk-03d362e9":"4c419337","chunk-2d0b6aab":"ab1b9db1","chunk-2d0c156c":"7ceccfd9","chunk-3a52e903":"f8e4095f","chunk-c0788482":"b49b1f3f","chunk-88295540":"8484cde4","chunk-8829adea":"d9a286eb","chunk-8ec5a618":"6c4d4906","AmCharts":"d9aa02a5","chunk-3cc585d0":"bd18009c","chunk-7f2edc08":"43bb2248","chunk-95b1b1b6":"2ae7f98a","chunk-2e94eee0":"e4853978","chunk-96a06da4":"0471e606","chunk-9eb0624a":"3d829a1d","chunk-a1c61ce6":"df5db218","chunk-ab5f5c1e":"40905d2c","chunk-ac93b83e":"8c847465","chunk-af6aabda":"907bd46f","chunk-b1d1856a":"ed9c48c4","chunk-b1fcf3b0":"29edee8b","chunk-b2342a7e":"e1f87563","chunk-b2b665cc":"fbc7ee8c","chunk-b7ac6afa":"d51de5f1","chunk-187aacc6":"2dea9f62","chunk-2d238f28":"f62e2237","chunk-bcf2add4":"69e9cfad","chunk-c490784c":"db879f3e","ApexChart":"a1efc4cb","chunk-2d0be333":"6bf8a889","chunk-2ca3ab94":"c54665bd","chunk-324cadc7":"c926171f","chunk-3f9f3a71":"c0bc3aad","chunk-47e6a99f":"612f75aa","chunk-0299ebf0":"20dcead9","chunk-745a67e4":"e3a3b4d6","chunk-7c4a830e":"2e958c83","chunk-ac0dbb00":"e45a5d85","chunk-c6a64654":"cb00be21","chunk-c944c0e8":"c25e9588","chunk-ccc560f6":"fc8c9c9c","chunk-d37b5e1e":"a9a5030f","chunk-dd0f210e":"a7b83059","chunk-e0dae6fc":"8c5f8b5a","chunk-ed4297b2":"4c5cc172","chunk-eeb03c00":"c7508aad","chunk-2d2222f9":"d32a50ed","canvg":"2833c00c","xlsx":"8edb3fa5","pdfmake":"dbceacda","chunk-6cf5d156":"87cdf8ce"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-069c39b2":1,"chunk-0ed070e4":1,"chunk-10de2f8e":1,"chunk-122008f8":1,"chunk-13f3215e":1,"chunk-159956d9":1,"chunk-19a3accc":1,"chunk-1c24da7b":1,"chunk-21481cb4":1,"chunk-217b2e92":1,"chunk-26969f90":1,"chunk-2b0a2569":1,"chunk-281a48e4":1,"chunk-29f55c97":1,"chunk-7cddbf05":1,"chunk-3f7871e3":1,"chunk-b3b78c88":1,"chunk-bbdb5e62":1,"chunk-2200adb7":1,"chunk-f2256754":1,"chunk-33efa541":1,"chunk-53bc0ede":1,"chunk-75383bc3":1,"chunk-b3869918":1,"chunk-04188563":1,"chunk-4a8e3c68":1,"chunk-4bbc9ae6":1,"chunk-4ffedc49":1,"chunk-55508ccf":1,"chunk-595881f2":1,"chunk-77b2bf02":1,"chunk-c0788482":1,"chunk-2e94eee0":1,"chunk-ac93b83e":1,"chunk-b1d1856a":1,"chunk-b1fcf3b0":1,"chunk-b2b665cc":1,"chunk-b7ac6afa":1,"chunk-187aacc6":1,"chunk-bcf2add4":1,"chunk-47e6a99f":1,"chunk-0299ebf0":1,"chunk-7c4a830e":1,"chunk-ac0dbb00":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"HighCharts":"HighCharts","AmCharts":"AmCharts","ApexChart":"ApexChart","canvg":"canvg","xlsx":"xlsx","pdfmake":"pdfmake"}[chunkId]||chunkId) + "." + {"HighCharts":"31d6cfe0","chunk-00708955":"31d6cfe0","chunk-069c39b2":"cda1c33e","chunk-0a7afad9":"31d6cfe0","chunk-0ed070e4":"84ee4d47","chunk-0f330e6e":"31d6cfe0","chunk-10de2f8e":"f997472d","chunk-2d0e5f17":"31d6cfe0","chunk-122008f8":"f0ef05e2","chunk-133a29fb":"31d6cfe0","chunk-13d049f5":"31d6cfe0","chunk-13f3215e":"00bad998","chunk-159956d9":"4bc5755e","chunk-19a3accc":"bc5d6a93","chunk-1ac6c498":"31d6cfe0","chunk-1c24da7b":"17486d2a","chunk-21481cb4":"12656ec4","chunk-217b2e92":"f2c145df","chunk-25ebe9a8":"31d6cfe0","chunk-264d486b":"31d6cfe0","chunk-26969f90":"374a13c2","chunk-277a78fa":"31d6cfe0","chunk-2a206364":"31d6cfe0","chunk-2b0a2569":"711db87f","chunk-2d0a4c18":"31d6cfe0","chunk-2d0ac5dd":"31d6cfe0","chunk-2d0ae599":"31d6cfe0","chunk-2d0afe6a":"31d6cfe0","chunk-2d0b3dcd":"31d6cfe0","chunk-2d0b8e0a":"31d6cfe0","chunk-2d0bacb6":"31d6cfe0","chunk-2d0bd5e9":"31d6cfe0","chunk-2d0bfed3":"31d6cfe0","chunk-2d0c04b2":"31d6cfe0","chunk-2d0c5368":"31d6cfe0","chunk-2d0c5398":"31d6cfe0","chunk-2d0c7b81":"31d6cfe0","chunk-2d0c840a":"31d6cfe0","chunk-2d0cbad6":"31d6cfe0","chunk-2d0cbe59":"31d6cfe0","chunk-2d0cc807":"31d6cfe0","chunk-2d0ccbc7":"31d6cfe0","chunk-2d0cedba":"31d6cfe0","chunk-2d0d3a0a":"31d6cfe0","chunk-2d0d5c6b":"31d6cfe0","chunk-2d0d6377":"31d6cfe0","chunk-2d0da2e7":"31d6cfe0","chunk-2d0dda3b":"31d6cfe0","chunk-2d0e2123":"31d6cfe0","chunk-2d0e6514":"31d6cfe0","chunk-2d207398":"31d6cfe0","chunk-2d207f54":"31d6cfe0","chunk-2d209132":"31d6cfe0","chunk-2d20eda9":"31d6cfe0","chunk-6535798c":"31d6cfe0","chunk-2d20f7a3":"31d6cfe0","chunk-2d216798":"31d6cfe0","chunk-2d217eb6":"31d6cfe0","chunk-2d219fca":"31d6cfe0","chunk-2d21a395":"31d6cfe0","chunk-2d21d826":"31d6cfe0","chunk-2d226159":"31d6cfe0","chunk-2d2268fd":"31d6cfe0","chunk-2d2374f7":"31d6cfe0","chunk-2d238257":"31d6cfe0","chunk-2d5809e0":"31d6cfe0","chunk-2da2eae6":"31d6cfe0","chunk-30a97249":"31d6cfe0","chunk-33192879":"31d6cfe0","chunk-38360029":"31d6cfe0","chunk-281a48e4":"e7c95099","chunk-29f55c97":"0b4edc85","chunk-7cddbf05":"0ce170a2","chunk-3c1a52a8":"31d6cfe0","chunk-3f7871e3":"85c3f610","chunk-b3b78c88":"d153a058","chunk-bbdb5e62":"39d8f518","chunk-2200adb7":"79adfbf3","chunk-f2256754":"4b53b3d5","chunk-33efa541":"4fa9c124","chunk-53bc0ede":"69f3f753","chunk-75383bc3":"47128161","chunk-b3869918":"c28f5623","chunk-4a49d1f9":"31d6cfe0","chunk-04188563":"3e7622d9","chunk-2d0c46e5":"31d6cfe0","chunk-4a8e3c68":"9e9cc0ae","chunk-4bbc9ae6":"9e9cc0ae","chunk-4ffedc49":"d1594a1d","chunk-54ad82df":"31d6cfe0","chunk-55508ccf":"1612b4ce","chunk-5881a87b":"31d6cfe0","chunk-595881f2":"a73e7f11","chunk-5af2ec7c":"31d6cfe0","chunk-62fe045e":"31d6cfe0","chunk-758d23ba":"31d6cfe0","chunk-77b2bf02":"05b5605a","chunk-78b53006":"31d6cfe0","chunk-7c6ce858":"31d6cfe0","chunk-7ca2337b":"31d6cfe0","chunk-7ea345ab":"31d6cfe0","chunk-7f7d0fc8":"31d6cfe0","chunk-20ee07b8":"31d6cfe0","chunk-03d362e9":"31d6cfe0","chunk-2d0b6aab":"31d6cfe0","chunk-2d0c156c":"31d6cfe0","chunk-3a52e903":"31d6cfe0","chunk-c0788482":"c1d12eb6","chunk-88295540":"31d6cfe0","chunk-8829adea":"31d6cfe0","chunk-8ec5a618":"31d6cfe0","AmCharts":"31d6cfe0","chunk-3cc585d0":"31d6cfe0","chunk-7f2edc08":"31d6cfe0","chunk-95b1b1b6":"31d6cfe0","chunk-2e94eee0":"0bd94ee3","chunk-96a06da4":"31d6cfe0","chunk-9eb0624a":"31d6cfe0","chunk-a1c61ce6":"31d6cfe0","chunk-ab5f5c1e":"31d6cfe0","chunk-ac93b83e":"1c69dda7","chunk-af6aabda":"31d6cfe0","chunk-b1d1856a":"e644d53f","chunk-b1fcf3b0":"9e9cc0ae","chunk-b2342a7e":"31d6cfe0","chunk-b2b665cc":"99382685","chunk-b7ac6afa":"9db3d878","chunk-187aacc6":"ac9be05d","chunk-2d238f28":"31d6cfe0","chunk-bcf2add4":"5405d2da","chunk-c490784c":"31d6cfe0","ApexChart":"31d6cfe0","chunk-2d0be333":"31d6cfe0","chunk-2ca3ab94":"31d6cfe0","chunk-324cadc7":"31d6cfe0","chunk-3f9f3a71":"31d6cfe0","chunk-47e6a99f":"690d0373","chunk-0299ebf0":"efacd1bf","chunk-745a67e4":"31d6cfe0","chunk-7c4a830e":"f2172597","chunk-ac0dbb00":"426631a5","chunk-c6a64654":"31d6cfe0","chunk-c944c0e8":"31d6cfe0","chunk-ccc560f6":"31d6cfe0","chunk-d37b5e1e":"31d6cfe0","chunk-dd0f210e":"31d6cfe0","chunk-e0dae6fc":"31d6cfe0","chunk-ed4297b2":"31d6cfe0","chunk-eeb03c00":"31d6cfe0","chunk-2d2222f9":"31d6cfe0","canvg":"31d6cfe0","xlsx":"31d6cfe0","pdfmake":"31d6cfe0","chunk-6cf5d156":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-8ec5a618","AmCharts","chunk-c490784c","ApexChart","HighCharts"]]);
 	return startupResult;
